// @flow

import { getPaymentType, getPaymentTypeCode } from '@tectonics/prs/incoming-payment';
import { type IncomingPayment } from './types';

const VALID_PAYMENT_TYPES = ['ewallet', 'webpay'];
const SKIP_PAYMENT_TYPE_CODES = ['nequi'];

export function isValidPendingPaymentToRedirect(incomingPayment: IncomingPayment): bool {
  const paymentType = getPaymentType(incomingPayment);
  const paymentTypeCode = getPaymentTypeCode(incomingPayment);

  return VALID_PAYMENT_TYPES.includes(paymentType) 
    && !SKIP_PAYMENT_TYPE_CODES.includes(paymentTypeCode);
}
